import { useEffect } from "react";

import { useAuth } from "./authContext";
import { withReturnTo } from "./returnTo";

/**
 * Redirects to an external URL (e.g. Hub) once the session check completes,
 * carrying the current page as `?returnTo=` so login can send the user back.
 */
export function useRedirectWhenUnauthenticated(url: string) {
  const { user, loading } = useAuth();

  useEffect(() => {
    if (!loading && !user) {
      window.location.href = withReturnTo(url);
    }
  }, [user, loading, url]);
}
